import {
  brazilFlag,
  germanyFlag,
  australiaFlag,
  emeaIcon,
  americasIcon,
  asiaIcon,
} from "../../../../assets/icons";
import {
  carolinaPng,
  zeeshanPng,
  guilhermePng,
  zeeshanmp4,
  carolinamp4,
  guilhermemp4,
} from "../../../../assets/media";

export const hostData = [
  {
    name: "Guilherme",
    id: "gh",
    location: {
      region: "Latin America",
      regionIcon: americasIcon,
      country: "Brazil",
      countryIcon: brazilFlag,
    },
    jobTitle: "iGEM Producer",
    theme: "The Stories of iGEM",
    photo: guilhermePng,
    linkedIn: "https://www.linkedin.com/in/guilherme-kundlatsch-8940a5132/",
    experience: [
      { year: 2014, title: "Brazil-SP: Student" },
      { year: 2016, title: "Sheffield: Advisor" },
      { year: 2017, title: "Ambassador" },
      { year: 2018, title: "Ambassador Coordinator" },
      { year: 2019, title: "After iGEM Coordinator" },
      { year: 2020, title: "After iGEM Coordinator" },
    ],
    video: guilhermemp4,
  },
  {
    name: "Carolina",
    id: "cl",
    location: {
      region: "Europe",
      regionIcon: emeaIcon,
      country: "Germany",
      countryIcon: germanyFlag,
    },
    jobTitle: "Global iGEM Ambassador Program Coordinator",
    theme: "The 2021 Journey",
    photo: carolinaPng,
    linkedIn: "https://www.linkedin.com/in/mcelizondo/",
    experience: [
      { year: 2012, title: "PrepaTec_GarzaSadaMx: Student" },
      { year: 2014, title: "Tec-Monterrey: Collaborator" },
      { year: 2015, title: "Tec-Monterrey: Student" },
      { year: 2016, title: "Tec-Monterrey: Student team leader" },
      { year: 2018, title: "Tec-Monterrey: Advisor" },
      { year: 2019, title: "Tec-Monterrey: Advisor" },
      { year: 2020, title: "Ambassador to Europe" },
    ],
    video: carolinamp4,
  },
  {
    name: "Zeeshan",
    id: "zs",
    location: {
      region: "Asia/Oceania",
      regionIcon: asiaIcon,
      country: "Australia",
      countryIcon: australiaFlag,
    },
    jobTitle: "iGEM Director of Digital Science Journalism",
    theme: "Imagining the Future",
    photo: zeeshanPng,
    linkedIn: "https://www.linkedin.com/in/zeeshan-siddiqui-464ab9130/",
    experience: [
      { year: 2018, title: "UNSW Sydney" },
      { year: 2020, title: "Ambassador" },
    ],
    video: zeeshanmp4,
  },
];
